import { Component } from '@angular/core';

@Component({
    selector: '[app-footer]',
    standalone: true,
    templateUrl: './app.footer.html'
})
export class AppFooter {}
